<script>
import CalendarMiniPostsCard from './CalendarMiniPostsCard.vue';

export default {
    name: 'CalendarMiniPosts',
    inject: ['$t'],
    components: {
        CalendarMiniPostsCard
    },
    data() {
        return {
            isActive: true
        };
    },
    props: {
        formattedDate: {
            type: Object,
            required: true
        },
        posts: {
            type: Array,
            required: true
        }
    },
    methods: {
        toggleValue() {
            this.isActive = !this.isActive;
        }
    }
};
</script>

<template>
    <div class="w-full pt-4 lg:pb-4">
        <div
            class="post-wrapper max-h-[690px] overflow-hidden px-4"
            :class="isActive ? 'expand' : ''"
        >
            <template v-if="posts.length !== 0">
                <slot name="posts" :posts="posts">
                    <CalendarMiniPostsCard
                        v-for="(post, index) in posts"
                        :key="index"
                        :post="post"
                        :class="posts.length > 1 ? 'post-element' : ''"
                    />
                </slot>
            </template>
        </div>
        <div
            class="absolute left-0 right-0 bottom-[17px] my-0 mx-auto flex hidden h-6 w-full items-center justify-center text-center lg:block"
        >
            <a href="/calendar">
                <span class="text-sl-v3 pr-2">{{
                    $t('View the entire calendar')
                }}</span>
                <i class="sw-icons-sm-external-link -mb-0.5"></i>
            </a>
        </div>
        <div
            class="flex justify-center pb-4 text-center lg:hidden"
            v-if="posts.length > 1"
            @click="toggleValue()"
        >
            <i v-if="isActive" class="sw-icons-chevrons-down"></i>
            <i v-else class="sw-icons-chevrons-up"></i>
        </div>
    </div>
</template>
<style lang="postcss" scoped>
.post-wrapper {
    transition: max-height 0.3s ease;

    @screen lg {
        @apply overflow-hidden;
    }
}

.expand {
    @apply max-h-[130px] overflow-y-hidden;

    .post-element {
        @apply invisible first:visible;
    }

    @screen lg {
        @apply h-full max-h-full;

        .post-element {
            @apply visible;
        }
    }
}

.post-element:nth-child(4) {
    @screen lg {
        @apply invisible;
    }
}

.post-element:first-child {
    @apply mt-4;
}
</style>
